import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emp-train',
  templateUrl: './emp-train.component.html',
  styleUrls: ['./emp-train.component.css']
})
export class EmpTrainComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
